const dessert = [];
dessert.push(
    "gelatine",
    "chocolate powder"
);

export default dessert;
